// extracted by mini-css-extract-plugin
module.exports = {"brandingsNew":"_3XUoy","brandingLogo":"_26NFj","upgrade":"_37Bqf"};